module.exports = __webpack_public_path__ + "img/iconXiTongHuoCheLieBiao.d0ce4722.svg";